import angular from 'angular';
import constants from 'app/constants';
import {
  pmDataService,
  pmSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import controller from './document-supporting-document.controller';
import directive from './document-supporting-document.directive';


export default angular.module('app.components.advisory.pm.documentSupportingDocument', [
  alerts,
  pmDataService,
  pmSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('pmDocumentSupportingDocument', directive)
  .controller('DocumentSupportingDocumentController', controller)
  .name;

console.log('app.components.advisory.pm.documentSupportingDocument created');
